import React from "react";

interface IntroProps {
  [key: string]: any
}

const Intro: React.FC<IntroProps> = (props: any) => {

  const appeal = (window as any).KEW.collections.appeal[0]

  return (
    <>
      <div className="row intro">
        <div className="large-12 columns box">
          <div className="intro-copy">
            <h1>{appeal.landing_page_title}</h1>
            <div className="mobile-image show-for-small-only">
              <img src={appeal.landing_page_mobile_image} alt={appeal.landing_page_image_alt} />
            </div>
            { props.values.payment_type === 'Single' &&
              <div dangerouslySetInnerHTML={{ __html: appeal.single_intro_text}}></div>
            }
            { props.values.payment_type === 'Regular' &&
              <div dangerouslySetInnerHTML={{ __html: appeal.regular_intro_text}}></div>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default Intro;